/*
 * author: dch
 */
import { ajax } from "@/utils/request";

const api = {
  // 企业公告列表
  getNoticeList(data: any) {
    return ajax({
      method: "get",
      url: `bullet/list`,
      data,
    });
  },
  // 企业公告列表
  createNotice(data: any) {
    return ajax({
      method: "post",
      url: `bullet/create`,
      data,
    });
  },
  // 发布
  publishNotice(id: any) {
    return ajax({
      method: "post",
      url: `bullet/publish/${id}`,
    });
  },
  // 撤回
  cancelNotice(id: any) {
    return ajax({
      method: "post",
      url: `bullet/cancel/${id}`,
    });
  },
  // 移除
  delNotice(id: any) {
    return ajax({
      method: "post",
      url: `bullet/remove/${id}`,
    });
  },
  // 移除
  delSympathyLogInfo(id: any) {
    return ajax({
      method: "delete",
      url: `sympathy-mgt/sympathy/${id}`,
    });
  },
  // 公告详情
  getNotice(id: any) {
    return ajax({
      method: "get",
      url: `bullet/get/${id}`,
    });
  },
  // 修改公告
  upDateNotice(data: any) {
    return ajax({
      method: "post",
      url: `bullet/update`,
      data,
    });
  },
  // 获取项目班组
  getProjectClassList(data: any) {
    return ajax({
      method: "get",
      url: `labour-class-member/query-project-class-list`,
    });
  },
  // 获取带供应商和班组的项目列表
  getProjectClassAndSupplierList(data: any) {
    return ajax({
      method: "get",
      url: `project-mgt/query-project-class-list`,
    });
  },
  // 获取项目供应商
  getProjectDeepSupplierList(){
    return ajax({
      method: "get",
      url: `labour-supplier-mgt/get-project-supplier-list`,
    });
  },
  // 获取付款申请列表
  getProjectPaymentList(data: any) {
    return ajax({
      method: "get",
      url: `payment-mgt/payment-page`,
      data,
    });
  },
  // 获取财务部付款申请列表
  getFianceProjectPaymentList(data: any) {
    return ajax({
      method: "get",
      url: `payment-mgt/project-confirm-page`,
      data,
    });
  },
  // 综合部确认付款
  confirmPayment(id: any) {
    return ajax({
      method: "put",
      url: `payment-mgt/payment/confirm/${id}`,
    });
  },
  // 综合部确认付款-材料劳务/双包
  confirmPaymentLabour(id:any){
    return ajax({
      method: "put",
      url: `payment-mgt/payment/confirm-labour/${id}`,
    });
  },
  // 财务部确认付款-材料劳务/双包
  confirmPaymentMaterial(id:any,contractId:any){
    return ajax({
      method: "put",
      url: `payment-mgt/payment/confirm-material/${id}`,
      data:{
        labourDoubleContractId: contractId
      }
    });
  },
  // 劳务罚款确认
  confirmFines(id: any){
    return ajax({
      method: "put",
      url: `payment-mgt/payment/confirm-fines/${id}`,
    });
  },
  // 新增劳务税金
  createLabourTax(data: any) {
    return ajax({
      method: "post",
      url: `labour/tax-registration`,
      data,
    });
  },
  // 获取劳务税金
  getLabourTaxDetails(id: any) {
    return ajax({
      method: "get",
      url: `labour/tax-registration/${id}`,
    });
  },
  // 修改劳务税金
  editLabourTax(data: any) {
    return ajax({
      method: "put",
      url: `labour/tax-registration/${data.id}?taxRate=${data.taxRate}`,
    });
  },
  // 移除劳务税金
  delLabourTax(id: any) {
    return ajax({
      method: "delete",
      url: `labour/tax-registration/${id}`,
    });
  },
  // 劳务付款导出
  exportPayment(data: any) {
    return ajax({
      method: "get",
      url: `payment-mgt/export`,
      type: "blob",
      data,
    });
  },
  // 劳务付款导出
  exportLabourPayment1(data: any) {
    return ajax({
      method: "get",
      url: `payment-mgt/export-labour`,
      type: "blob",
      data,
    });
  },

  // 确认收款
  confirmTaxRegistration(id: any) {
    return ajax({
      method: "put",
      url: `labour/tax-registration/confirm/${id}`,
    });
  },
  // 下载证书
  downLoadCertificate(id: any, fileId: any) {
    return ajax({
      method: "get",
      url: `certificate-mgt/certificate/${id}/${fileId}`,
      type: "blob",
    });
  },
  // 劳务税金导出
  exportLabourTax(data: any) {
    return ajax({
      method: "get",
      url: `labour/tax-registration/export`,
      type: "blob",
      data,
    });
  },
  //获取办公用品分类
  getOfficeClassifiesList() {
    return ajax({
      method: "get",
      url: `office-category-mgt/list`,
    });
  },
  //新增公用品分类
  addOfficeClassifiesName(data: any) {
    return ajax({
      method: "post",
      url: `office-category-mgt/office-category`,
      data,
    });
  },
  //修改公用品分类
  editOfficeClassifiesName(data: any, id: any) {
    return ajax({
      method: "put",
      url: `office-category-mgt/office-category/${id}`,
      data,
    });
  },
  //修改公用品分类
  delOfficeClassifiesName(id: any) {
    return ajax({
      method: "delete",
      url: `office-category-mgt/office-category/${id}`,
    });
  },
  //修改公用品分类
  getOfficeClassDataList(data: any) {
    return ajax({
      method: "get",
      url: `office-supplies-mgt/office-supplies`,
      data,
    });
  },
  //退还入库选择材料接口
  getOfficeSuppliesBack(data: any){
    return ajax({
      method: "get",
      url: `office-in-mgt/supplies`,
      data,
    });
  },
  //新增办公用品
  createOfficeMaterial(data: any) {
    return ajax({
      method: "post",
      url: `office-supplies-mgt/office-supplies`,
      data,
    });
  },
  //修改办公用品
  upDateOfficeMaterial(data: any, id: any) {
    return ajax({
      method: "put",
      url: `office-supplies-mgt/office-supplies/${id}`,
      data,
    });
  },
  //品牌
  getBrandOfficeList(data: any) {
    return ajax({
      method: "get",
      url: `brand-mgt/select-brand-list`,
    });
  },
  //办公用品供应商
  getOfficeSupplierList(data: any) {
    return ajax({
      method: "get",
      url: `office-supplier-mgt/office-supplier`,
      data,
    });
  },
  //禁用供应商
  disabledOfficeSupplier(id: any) {
    return ajax({
      method: "put",
      url: `office-supplier-mgt/${id}/disabled`,
    });
  },
  //启用供应商
  enabledOfficeSupplier(id: any) {
    return ajax({
      method: "put",
      url: `office-supplier-mgt/${id}/enabled`,
    });
  },
  //新增供应商
  createOfficeSupplier(data: any) {
    return ajax({
      method: "post",
      url: `office-supplier-mgt/office-supplier`,
      data,
    });
  },
  //获取供应商
  getOfficeSupplierDetails(id: any) {
    return ajax({
      method: "get",
      url: `office-supplier-mgt/office-supplier/${id}`,
    });
  },
  //修改供应商
  editOfficeSupplier(data: any, id: any) {
    return ajax({
      method: "put",
      url: `office-supplier-mgt/office-supplier/${id}`,
      data,
    });
  },
  //移除供应商
  delOfficeSupplier(id: any) {
    return ajax({
      method: "delete",
      url: `office-supplier-mgt/office/${id}`,
    });
  },
  //供应商列表
  getSupplierOfficeList() {
    return ajax({
      method: "get",
      url: `office-supplier-mgt/list`,
    });
  },
  //获取办公用品信息
  getOfficeMaterDetails(id: any) {
    return ajax({
      method: "get",
      url: `office-supplies-mgt/office-supplies/${id}`,
    });
  },
  //禁用材料
  disabledOfficeMaterial(id: any) {
    return ajax({
      method: "put",
      url: `office-supplies-mgt/${id}/disabled`,
    });
  },
  //启用材料
  enabledOfficeMaterial(id: any) {
    return ajax({
      method: "put",
      url: `office-supplies-mgt/${id}/enabled`,
    });
  },
  //移除材料
  delOfficeMaterial(id: any) {
    return ajax({
      method: "delete",
      url: `office-supplies-mgt/office-supplies/${id}`,
    });
  },
  //获取企业信息
  getTenantInfo() {
    return ajax({
      method: "get",
      url: `tenant-mgt/tenant`,
    });
  },
  //保存企业信息
  saveTenantInfo(data: any) {
    return ajax({
      method: "put",
      url: `tenant-mgt/tenant`,
      data,
    });
  },
  //企业证书分类列表
  getCertificateCategoryList() {
    return ajax({
      method: "get",
      url: `certificate-category-mgt/list`,
    });
  },
  //新增企业证书分类
  addCertificateCategoryName(data: any) {
    return ajax({
      method: "post",
      url: `certificate-category-mgt/certificate-category`,
      data,
    });
  },
  //企业证书分类列表
  editCertificateCategoryName(data: any, id: any) {
    return ajax({
      method: "put",
      url: `certificate-category-mgt/certificate-category/${id}`,
      data,
    });
  },
  //移除企业证书分类
  delCertificateCategoryName(id: any) {
    return ajax({
      method: "delete",
      url: `certificate-category-mgt/certificate-category/${id}`,
    });
  },
  //移除企业证书分类
  getCertificateDataList(data: any) {
    return ajax({
      method: "get",
      url: `certificate-mgt/certificate`,
      data,
    });
  },
  //新建企业证书
  createCertificateInfo(data: any) {
    return ajax({
      method: "post",
      url: `certificate-mgt/certificate`,
      data,
    });
  },
  //获取企业证书
  getCertificateDetails(id: any) {
    return ajax({
      method: "get",
      url: `certificate-mgt/certificate/${id}`,
    });
  },
  //修改企业证书
  updateCertificateDetails(data: any, id: any) {
    return ajax({
      method: "put",
      url: `certificate-mgt/certificate/${id}`,
      data,
    });
  },
  //移除企业证书
  delCertificate(id: any) {
    return ajax({
      method: "delete",
      url: `certificate-mgt/certificate/${id}`,
    });
  },
  //新增员工信息
  createEmployeeInfo(data: any) {
    return ajax({
      method: "post",
      url: `sys-employee-mgt/employee`,
      data,
    });
  },
  //员工信息
  getEmployeesDetails(id: any) {
    return ajax({
      method: "get",
      url: `sys-employee-mgt/employees/${id}`,
    });
  },
  //新增员工信息
  editEmployeeInfo(data: any, id: any) {
    return ajax({
      method: "put",
      url: `sys-employee-mgt/employees/${id}`,
      data,
    });
  },
  //项目慰问分页
  getSympathyList(data: any) {
    return ajax({
      method: "get",
      url: `sympathy-mgt/sympathy`,
      data,
    });
  },
  //项目慰问分页
  createSympathy(data: any) {
    return ajax({
      method: "post",
      url: `sympathy-mgt/sympathy`,
      data,
    });
  },
  //项目慰问分页
  upDateSympathy(data: any, id: any) {
    return ajax({
      method: "put",
      url: `sympathy-mgt/sympathy/${id}`,
      data,
    });
  },
  //项目慰问分页
  getSympathyInfo(id: any) {
    return ajax({
      method: "get",
      url: `sympathy-mgt/sympathy/${id}`,
    });
  },
  //项目慰问分页
  getEmployeeProject(id: any) {
    return ajax({
      method: "get",
      url: `sys-employee-mgt/rel-project/${id}`,
    });
  },
  //公用品采购申请分页
  getOfficePurchaseList(data: any) {
    return ajax({
      method: "get",
      url: `office-purchase-mgt/office`,
      data,
    });
  },
  //增办公用品采购申请
  createOfficePurchase(data: any) {
    return ajax({
      method: "post",
      url: `office-purchase-mgt/office`,
      data,
    });
  },
  //增办公用品采购申请
  getOfficePurchaseInfo(id: any) {
    return ajax({
      method: "get",
      url: `office-purchase-mgt/office/${id}`,
    });
  },
  //修改办公用品采购申请
  updateOfficePurchase(data: any, id: any) {
    return ajax({
      method: "put",
      url: `office-purchase-mgt/office/${id}`,
      data,
    });
  },
  //修改办公用品采购申请
  setOfficePurchaseRejected(data: any, id: any) {
    return ajax({
      method: "put",
      url: `office-purchase-mgt/${id}/reject`,
      data,
    });
  },
  //办公用品库存分页
  getOfficeStockList(data: any) {
    return ajax({
      method: "get",
      url: `office-stock-mgt/office`,
      data,
    });
  },
  //办公用品入库登记明细分页
  getOfficeIntoList(data: any) {
    return ajax({
      method: "get",
      url: `office-in-mgt/office`,
      data,
    });
  },
  //办公用品入库登记明细分页
  createOfficeInto(data: any) {
    return ajax({
      method: "post",
      url: `office-in-mgt/office`,
      data,
    });
  },
  //企业制度分页
  getInstitutionList(data: any) {
    return ajax({
      method: "get",
      url: `institution-mgt/institution`,
      data,
    });
  },
  //新增企业制度
  createInstitutionInfo(data: any) {
    return ajax({
      method: "post",
      url: `institution-mgt/institution`,
      data,
    });
  },
  //修改企业制度
  editInstitutionInfo(data: any, id: any) {
    return ajax({
      method: "put",
      url: `institution-mgt/institution/${id}`,
      data,
    });
  },
  //修改企业制度
  getInstitutionInfo(id: any) {
    return ajax({
      method: "get",
      url: `institution-mgt/institution/${id}`,
    });
  },
  //移除企业制度
  delInstitutionInfo(id: any) {
    return ajax({
      method: "delete",
      url: `institution-mgt/institution/${id}`,
    });
  },
  //移除企业制度
  getCustomerInfoList(data: any) {
    return ajax({
      method: "get",
      url: `customer-info-mgt/customer`,
      data,
    });
  },
  //新增客户信息入库
  createCustomerIntoInfo(data: any) {
    return ajax({
      method: "post",
      url: `customer-info-mgt/customer`,
      data,
    });
  },
  //x修改客户信息入库
  editCustomerIntoInfo(data: any, id: any) {
    return ajax({
      method: "put",
      url: `customer-info-mgt/customer/${id}`,
      data,
    });
  },
  //获取客户信息入库
  getCustomerIntoDetails(id: any) {
    return ajax({
      method: "get",
      url: `customer-info-mgt/customer/${id}`,
    });
  },
  //移除客户信息入库
  delCustomerIntoInfo(id: any) {
    return ajax({
      method: "delete",
      url: `customer-info-mgt/customer/${id}`,
    });
  },
  //甲方合同管理分页
  getDocumentsFirstContractList(data: any) {
    return ajax({
      method: "get",
      url: `first-contract-documents-mgt/documents`,
      data,
    });
  },
  //甲方合同管理分页
  getDocumentsFirstContractDetails(id: any) {
    return ajax({
      method: "get",
      url: `first-contract-documents-mgt/documents/${id}`,
    });
  },
  //甲方合同下载
  downloadDocumentsFirstContract(data: any){
    return ajax({
      method: "get",
      url: `first-contract-documents-mgt/export`,
      data,
      type:"blob"
    });
  },
  //修改甲方合同管理
  saveFirstContractDocument(data: any, id: any) {
    return ajax({
      method: "put",
      url: `first-contract-documents-mgt/documents/${id}`,
      data,
    });
  },
  //供应商合同管理分页
  getSupplierContractDocumentsList(data: any) {
    return ajax({
      method: "get",
      url: `supplier-contract-documents-mgt/documents`,
      data,
    });
  },
  //修改供应商合同管理
  saveSupplierContractDocuments(data: any, id: any) {
    return ajax({
      method: "put",
      url: `supplier-contract-documents-mgt/documents/${id}`,
      data,
    });
  },
  //供应商合同下载
  downloadSupplierContractContract(data: any){
    return ajax({
      method: "get",
      url: `supplier-contract-documents-mgt/export`,
      data,
      type:"blob"
    });
  },
  //证书下载日志
  getCertificateDownList(data: any, id: any) {
    return ajax({
      method: "get",
      url: `certificate-mgt/certificate/download-log`,
      data,
    });
  },

  // 新增面试
  addInterviewDetails(data: any) {
    return ajax({
      method: "POST",
      url: `interview-mgt/interview`,
      data,
    });
  },

  // 编辑面试
  editInterviewDetails(data: any) {
    return ajax({
      method: "PUT",
      url: `interview-mgt/interview/${data.id}`,
      data,
    });
  },

  // 获取面试
  getInterviewDetails(id: any) {
    return ajax({
      method: "GET",
      url: `interview-mgt/interview/${id}`,
    });
  },

  // 移除面试
  delInterviewDetails(id: any) {
    return ajax({
      method: "DELETE",
      url: `interview-mgt/interview/${id}`,
    });
  },

  // 面试列表
  getInterviewList(id: any) {
    return ajax({
      method: "GET",
      url: `interview-mgt/list`,
    });
  },

  // 新增办公用品出库登记明细
  addOfficeOutDetail(data: any) {
    return ajax({
      method: "POST",
      url: `office-out-mgt/office`,
      data
    });
  },

};

export default api;
